export default {"src":"/_next/static/media/discord.b19b8134.svg","height":96,"width":127,"blurWidth":0,"blurHeight":0};